import type { EventDetails } from "@/modules/eventDetails/client/api/types"
import type { FunctionComponent } from "react"

import { Companies } from "@/modules/eventDetails/client/components/Body/Companies"
import { Speakers } from "@/modules/eventDetails/client/components/Body/Speakers"
import { Divider } from "@/modules/eventDetails/client/components/Divider/Divider"
import { useEventDetailsData } from "@/modules/eventDetails/client/hooks/useEventDetailsData"

import { Description } from "./Description"

import layoutStyles from "@/modules/eventDetails/client/components/Layout/Layout.module.css"

export const Body: FunctionComponent = () => {
  const event = useEventDetailsData()

  if (!event) {
    return null
  }

  const { speakers, companies } = event as EventDetails

  return (
    <section className={layoutStyles.body} data-testid="event-details-body">
      <Description />
      {speakers.length > 0 && (
        <>
          <Divider />
          <Speakers />
        </>
      )}
      {companies && companies.length > 0 && (
        <>
          <Companies />
          <Divider />
        </>
      )}
    </section>
  )
}
